import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_CODE, LB_NAME, LB_ACTIVE, LB_PROJECT} from "../../../components/i18n/i18n";
import {PH_CODE, PH_NAME} from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {fbProjectProvider} from "../../../providers/fbProjectProvider";



const TranslateCountFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app } = componentState?.data || {};
    const {fbDataBase} = app

    const [project, setProject] = useState(filter?.project || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {  ...data, }
        };

        if (project !== undefined && project !== null)
            dataFilter.item.project = project;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setProject(null)
        reset({});
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <SelectGeneric
                            title={LB_PROJECT}
                            initialValue={project}
                            setExternalValue={setProject}
                            provider={fbProjectProvider}
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(TranslateCountFilters)